import { applyMiddleware, compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

import { toStorage } from "../utils/store-persist";

import rootReducer from "./root-reducer";
import { selectClosedNotices, selectClosedWhatsNew } from "./selectors/notices";
import { selectInsuranceType } from "./selectors/quote-quick-start";
import { CLOSED_NOTICES_KEY, CLOSED_WHATSNEW_KEY } from "./notices";
import { INSURANCE_TYPE_KEY } from "./quote-quick-start";

const store = configureStore({
  reducer: rootReducer,
  enhancers: [compose(applyMiddleware(thunk))],
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["rex"]
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const updateStorage = toStorage({
  [CLOSED_NOTICES_KEY]: selectClosedNotices,
  [CLOSED_WHATSNEW_KEY]: selectClosedWhatsNew,
  [INSURANCE_TYPE_KEY]: selectInsuranceType
});

store.subscribe(() => updateStorage(store.getState()));

if (module.hot) {
  module.hot.accept("./root-reducer", () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    store.replaceReducer(require("./root-reducer").default)
  );
}

export default store;
